export enum ResultStatus {
  Abnormal = "Abnormal",
  Good = "Good",
  CannotBeDetermined = "CannotBeDetermined",
}
